import { Component, ViewChild, ElementRef, ChangeDetectorRef, trigger } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Nav, NavParams, MenuController, Events, NavController, Content, LoadingController, ToastController, ActionSheetController, Config  } from 'ionic-angular';
import { FileTransfer, FileUploadOptions } from '@ionic-native/file-transfer';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { Base64 } from "@ionic-native/base64";
import { TabsPage } from "../../index";
import { File } from '@ionic-native/file';
import { FileChooser } from '@ionic-native/file-chooser';
import { FilePath } from '@ionic-native/file-path';

import { NewsMyRadiant, HelperMyRadiant } from '../../../../providers/';



@Component({
  selector: 'page-news',
  templateUrl: 'page.html'
})
export class NewsPage {  
  @ViewChild(Content) content: Content;  
  tab3Title = " ";
  btnTabNewsActive = 'public';
  akses_modul = 0;
  loading:any = {
    
  };
  ckeConfig: any = {
    height: 500
  };
  mycontent: string;
  log: string = '';
  // Kumpulan State 
  stateComponent: any = {
   
  }

  // Kumpulan Data
  data:any = {    
    state: 'add',
    defaultLoading : './assets/icon/loading.gif',    
    imageURI: "",
    imageFileName: "",
    menu_intranews: [],
    widget_intranews: [],
    menu_dashboard: [],
    widget_dashboard:[],
    permission_department: [],
  };

  dataFile:Object = {
    preview_main_image: "",
    filename_thumbnail:""
  }

  // Kumpulan parameter
  parameter:any = {
    
  }

  selectedData: Object = {
    menu_intranews: "",
    widget_intranews: "",
    menu_dashboard: "",
    widget_dashboard: "",
    permission: ""
  }
  

  formNews:Object ={
    id                      : "",
    dashboard_news_id       : "",
    dashboard_report_news_id: "",
    title                   : "",
    description             : "",
    image_content           : false,
    hightlight              : false,
    menu_intranews          : "",
    widget_intranews        : "",
    menu_dashboard          : "",
    widget_dashboard        : "",
    is_private              : false,
    permission              : "",
    main_image_id           : "",
    thumbnail_id            : "",
  };

  constructor(
    public  navCtrl        : NavController,
    public  menuCtrl       : MenuController,
    public  nav            : Nav,
    public  navParams      : NavParams,
    public  sanitizer      : DomSanitizer,
    private apiNews        : NewsMyRadiant,
    public  ref            : ChangeDetectorRef,
    private transfer       : FileTransfer,
    public  camera         : Camera,
    public  file           : File,
    private fileChooser    : FileChooser,
    private base64         : Base64,
    private filepath       : FilePath,
    public  loadingCtrl    : LoadingController,
    public  toastCtrl      : ToastController,
    public  actionSheetCtrl: ActionSheetController,
    public  helper         : HelperMyRadiant,
    public  config         : Config,
  ) {
    this.getMenuIntranews();    
    this.getMenuDashboard();   
    this.getPermissionDepartment();
    this.initDataParams();
  }

  initDataParams() {
    let data = this.navParams.get('data'),
      triggerSelect = {
        menu_intranews: "onChangeMenuIntranews",
        menu_dashboard: "onChangeMenuDashboard",
      };
          
    this.data["state"] = this.navParams.get('state');
    let title =  this.data['state'] === 'upd' ? 'Edit News' : 'Add News';
    this.config.set('backButtonText',title); 

    if (this.data["state"] == "upd" && data) {
      console.log(data);
      for (var name in this.selectedData) {
        if (name in data) {
          this.selectedData[name] = data[name];
          if (name in triggerSelect) {
            if (this[triggerSelect[name]]) {         
              this[triggerSelect[name]]({ value: data[name]})              
            }
          }
        }       
      }
      for (let name in this.dataFile) {
        if (name in data) {
          this.dataFile[name] = data[name];
        }
      }      
      for(let name in this.formNews) {
        if (name in data) {          
          this.formNews[name] = data[name];
        }
      }
    }
  }

  uploadFile(target) {
    let actionSheet = this.actionSheetCtrl.create({
      title: 'Pick file',
      buttons: [
        {
          text: 'From Gallery',

          handler: () => {
            this.chooseFile(target);
          }
        },
        {
          text: 'From Camera',
          handler: () => {
            this.showCamera(target);
          }
        },
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });

    actionSheet.present();
  }

  showCamera(target) {
    let me = this;
    const options: CameraOptions = {
      quality         : 25,
      destinationType : this.camera.DestinationType.FILE_URI,
      encodingType    : this.camera.EncodingType.JPEG,
      mediaType       : this.camera.MediaType.PICTURE,
      saveToPhotoAlbum: true,
      sourceType      : this.camera.PictureSourceType.CAMERA,
      cameraDirection : this.camera.Direction.FRONT
    }

    this.camera.getPicture(options).then((uri) => {
      this.setFile(uri, target);

    }, (err) => {
      // Handle error
    });
  }

  chooseFile(target) {
    let me = this;
    this.fileChooser.open()
      .then(uri => {
        this.setFile(uri, target);
      })
      .catch(e => console.log(e));
  }

  setFile(url, target) {
    let me = this;
    this.filepath.resolveNativePath(url).then(imageData => {
      if (target) {        
        me.dataFile["preview_" + target] = imageData;        
      }
      this.file.resolveLocalFilesystemUrl(imageData).then(file => {        
        if (target) {          
          me.dataFile["filename_" + target] = file.name;          
        }
      })
      this.base64.encodeFile(imageData).then((base64File: string) => {        
        if (target) {          
          me.dataFile["binary_" + target] = base64File;          
        }
      }, (err) => {
        console.log(err);
      });
    })
      .catch(err => console.log(err));
  }

  getMenuIntranews() {
    this.apiNews.getMenuIntranews({}).subscribe((resp: any) => {
      if (resp.success) {
        this.data.menu_intranews = resp.data; 
      }      
    }, (err) => {
      
    });
  }

  getWidgetIntranews(board_code) {
    let unix = new Date().getTime();
    this.loading[unix] = this.helper.showLoading("Load data...");
    this.apiNews.getWidgetIntranews({ bcode: board_code}).subscribe((resp: any) => {
      if (resp.success) {
        this.data.widget_intranews = resp.data;
      }
      try {
        this.loading[unix].dismiss();        
      } catch (error) {
        
      }
    }, (err) => {
        try {
          this.loading[unix].dismiss();
        } catch (error) {

        }
    });
  }

  getMenuDashboard() {
    this.apiNews.getMenuDashboard({}).subscribe((resp: any) => {
      if (resp.success) {
        this.data.menu_dashboard = resp.data;
      }
    }, (err) => {

    });
  }

  getWidgetDashboard(board_code) {
    let unix = new Date().getTime();
    this.loading[unix] = this.helper.showLoading("Load data...");
    this.apiNews.getWidgetDashboard({ bcode: board_code }).subscribe((resp: any) => {
      if (resp.success) {
        this.data.widget_dashboard = resp.data;
      }
      try {
        this.loading[unix].dismiss();        
      } catch (error) {
        
      }
    }, (err) => {
        try {
        this.loading[unix].dismiss();        
      } catch (error) {
        
      }
    });
  }

  getPermissionDepartment() {
    this.apiNews.getPermissionDepartment({}).subscribe((resp: any) => {
      if (resp.success) {
        this.data.permission_department = resp.data;
      }
    }, (err) => {

    });
  }

  doRefresh(refresher) {
    refresher.complete();
  }

  onChangeMenuIntranews(obj) {    
    if ("board_code" in obj.value) {
      this.getWidgetIntranews(obj.value.board_code);
      this.formNews["widget_intranews"] = "";    
      this.selectedData["widget_intranews"] = "";
    }
    this.formNews["menu_intranews"] = obj.value.id;
  }

  onChangeMenuDashboard(obj) {    
    if ("board_code" in obj.value) {
      this.getWidgetDashboard(obj.value.board_code);      
      this.formNews["widget_dashboard"] = "";    
      this.selectedData["widget_dashboard"] = "";
    }
    this.formNews["menu_dashboard"] = obj.value.id;
  }

  onChangeWidgetIntranews(obj) {
    this.formNews["widget_intranews"] = obj.value.id;
  }

  onChangeWidgetDashboard(obj) {
    this.formNews["widget_dashboard"] = obj.value.id;
  }

  onChangePermission(obj) {
    let permission_list = "";
    if (obj.value.length > 0) {
      permission_list = obj.value.map((row) => {
        return row.id;
      }).join();
    }
    this.formNews["permission"] = permission_list;
  }

  onChangePrivate(event) {
    this.formNews["menu_dashboard"] = "";
    this.formNews["widget_dashboard"] = "";
    this.formNews["permission"] = "";
    this.selectedData["menu_dashboard"] = "";
    this.selectedData["widget_dashboard"] = "";
    this.selectedData["permission"] = "";
  }

  clearFile(target) {
    this.dataFile["preview_" + target] = "";
    this.dataFile["filename_" + target] = ""
    this.dataFile["binary_" + target] = "";
  }

  saveNews() {

    let me = this,
      optionsSwal = {
        title: "Submit News",
        desc: "",
        icon: "",
        dangerMode: false,
        btnCancel: "Cancel",
        btnConfirm: "Submit",
      }
    this.helper.presentSwalConfirmation(optionsSwal, () => {
        let unix = new Date().getTime();
        this.loading[unix] = this.helper.showLoading("Preses...");
        let args = this.formNews,        
            fieldSelect = {
              menu_intranews: { value: 'id' },
              widget_intranews: { value: 'id' },
              menu_dashboard: { value: 'id' },
              widget_dashboard: { value: 'id' },
              permission: { value: 'id' },
            },
            data_user = JSON.parse(localStorage.data_user).data;
        
        if (this.dataFile) {
          for (let name in this.dataFile) {
            args[name] = this.dataFile[name];
          }
        }
    
        for (let name in args) {      
          if (name in fieldSelect) {
            try {
              if (args[name].length > 0) {
                args[name] = args[name].map((row) => {
                  return row[fieldSelect[name]['value']];
                }).join(",");            
              }
            } catch (e) {
              
            }
    
            try {
              if (fieldSelect[name]['value'] in args[name]) {
                args[name] = args[name][fieldSelect[name]['value']];
              }          
            } catch (e) {          
            }        
          }
        }
    
        if (data_user) {
          args["uid"] = data_user.Employee_ID;
          args["udept"] = data_user.Departemen;
        }
        console.log(args);
        // me.loading[unix].dismiss();
        this.apiNews.saveNews(args).subscribe((resp:any) => {
          if(resp.success) {        
            this.nav.setRoot(TabsPage, { tabIndex: 0 });        
          } else {
            
          }
          if ("msg" in resp) {        
            me.presentToast(resp.msg);
          }
          me.loading[unix].dismiss();
        },(err) => {
            me.presentToast(err);
            me.loading[unix].dismiss();      
        });
    });

  }

  presentToast(msg) {
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  ionViewDidLoad() {
   
  }
  
 
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/home/news/page.ts